let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let ProOnly = require("../../../../widgets/ProOnly");
let esUtils = require("ES/utils/esUtils");
let FormUtils = require("../../../../../utils/FormUtils");
let Constants = require("../../../../../utils/Constants");
let LabelEditorModal = require("./LabelEditorModal");
let AuthedUserSession = require("../../../../../utils/AuthedUserSession");
let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");
let createStandardEventForm = require("../../createStandardEventForm");
let getSpeakersFromDisplaylists = require("../../../../../utils/getSpeakersFromDisplaylists");

let tabs = {
  SHORT: {
    name: "Short",
    ids: _.range(0, Constants.QTYCUSTOMS),
  },
  LONG: {
    name: "Long",
    ids: _.range(100, 100 + Constants.QTYLONGCUSTOMS),
  },
};

let DaForm = createStandardEventForm({
  eventToInitialValues(event) {
    let sid = _.first(event && event.sids); //TODO fix this
    let contents =
      event && event.Customfields && event.Customfields.contents
        ? event.Customfields.contents
        : {};
    let fields = contents[sid];
    return _.object(
      _.map(fields, function (value, id) {
        return [id, value];
      })
    );
  },
  buildSchema({ event, Displaylists }) {
    let speaker = _.first(
      getSpeakersFromDisplaylists(Displaylists, event.sids)
    );
    let custom_labels = _.object(
      _.map(
        speaker &&
          _.filter(speaker.customfieldlabels, function (elm) {
            // filter custom field labels by company id
            return (
              _.parseInt(
                _.get(
                  elm,
                  ["coid"],
                  _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])
                )
              ) === _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])
            );
          }),
        function (elm) {
          return [elm.id, elm.lbl];
        }
      )
    );
    let schema = {};
    _.each(_.range(0, Constants.QTYCUSTOMS), function (id) {
      schema[id] = {
        label: custom_labels[id] ? custom_labels[id] : "--",
        type: "text",
        validate: FormUtils.v.optional,
      };
    });
    _.each(_.range(100, 100 + Constants.QTYLONGCUSTOMS), function (id) {
      schema[id] = {
        label: custom_labels[id] ? custom_labels[id] : "--",
        type: "textarea",
        validate: FormUtils.v.optional,
      };
    });
    return schema;
  },
  writeInputDataToEvent(data, event) {
    if (!event.Customfields) {
      event.Customfields = {
        id: 0,
        eid: event.eid,
      };
    }
    if (!_.isPlainObject(event.Customfields.contents)) {
      event.Customfields.contents = {};
    }
    let sid = _.first(event.sids); //TODO fix this
    event.Customfields.contents[sid] = data;
  },
  renderFields() {
    let { open_tab, tabs_to_render, clickTab } = this.props;

    return dd.div(
      null,
      _.size(tabs_to_render) > 1
        ? dd.ul(
            { className: "nav nav-tabs small", style: { marginBottom: 20 } },
            _.map(
              tabs_to_render,
              function (tab, tab_name) {
                return dd.li(
                  {
                    key: tab_name,
                    className: open_tab === tab_name ? "active" : null,
                  },
                  dd.a({ href: "#", onClick: clickTab(tab_name) }, tab.name)
                );
              },
              this
            )
          )
        : null,
      ezHorizontalFields(
        this,
        _.map(tabs_to_render[open_tab].ids, function (id) {
          return [id + ""];
        })
      )
    );
  },
});

module.exports = dd.createClass({
  getInitialState() {
    return { show_label_editor: false, open_tab: _.first(_.keys(tabs)) };
  },
  __clickTab(tab_clicked) {
    return _.bind(
      esUtils.wrapPreventDefault(function () {
        this.setState({ open_tab: tab_clicked });
      }),
      this
    );
  },
  __toggleLabelEditor: esUtils.wrapPreventDefault(function () {
    this.setState({ show_label_editor: !this.state.show_label_editor });
  }),
  render() {
    let { event, Displaylists } = this.props;
    let { open_tab, show_label_editor } = this.state;
    let can_I_edit_labels;
    if (AuthedUserSession.privatelabel_code === "st") {
      can_I_edit_labels = AuthedUserSession.doIHaveAccess.full.any(event.sids);
    } else {
      can_I_edit_labels = AuthedUserSession.doIHaveAccess.admin.any(event.sids);
    }

    let tabs_to_render = tabs;
    if (
      AuthedUserSession.privatelabel_code === "cs" &&
      !AuthedUserSession.doIHaveAccess.full.any(event.sids)
    ) {
      tabs_to_render = _.omit(tabs, "SHORT"); //it's important we don't actually mutate tabs
    }
    if (!_.has(tabs_to_render, open_tab)) {
      open_tab = _.first(_.keys(tabs_to_render));
    }

    return dd.div(
      { className: "Custom" },
      ProOnly(
        {
          sids: event.sids,
          custom_message:
            "Your business is unique. PRO users celebrate that with 10 short and 4 long custom fields to store the things that make your business special.",
        },
        dd.h2(
          null,
          "Custom Data",
          !can_I_edit_labels
            ? null
            : dd.a(
                {
                  className: "printlink pull-right",
                  onClick: this.__toggleLabelEditor,
                },
                dd.i({ className: "fa fa-gear" }),
                " customize labels"
              )
        ),
        dd.div({ className: "clearfix" }),
        DaForm({
          event,
          Displaylists,
          open_tab,
          read_only: !AuthedUserSession.doIHaveAccess.full.any(event.sids),
          tabs_to_render,
          clickTab: this.__clickTab,
        }),
        !show_label_editor
          ? null
          : LabelEditorModal({
              event,
              Displaylists,
              onClose: this.__toggleLabelEditor,
            })
      )
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/custom/index.js